import React from "react";
import { TextField } from "@material-ui/core";
import { useController } from "react-hook-form";
import { NumericFormat, PatternFormat } from "react-number-format";

// Кастомный компонент для форматирования валюты
const CurrencyFormat = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.floatValue || 0,
          },
        });
      }}
      thousandSeparator=" "
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale={true}
      allowNegative={false}
      allowLeadingZeros={false}
      valueIsNumericString={true}
      onFocus={(e) => {
        e.target.select();
      }}
      onBlur={(e) => {
        if (e.target.value === "" || e.target.value === "0,00") {
          props.onChange({
            target: {
              name: props.name,
              value: 0,
            },
          });
        }
      }}
    />
  );
});

// Кастомный компонент для маски серийного номера
const MaskFormat = React.forwardRef((props, ref) => {
  const { onChange, maskPattern, ...other } = props;

  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      format={maskPattern || ""}
      mask="_"
      allowEmptyFormatting={false}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value, // Передает чистую строку без символов маски (или values.formattedValue если нужны пробелы/символы)
          },
        });
      }}
    />
  );
});

const MyInput = (props) => {
  const { control, name, type, InputProps, maskPattern } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({
    name,
    control,
    defaultValue: type === "currency" ? 0 : "",
  });

  if (type === "currency") {
    return (
      <TextField
        {...inputProps}
        InputProps={{
          inputComponent: CurrencyFormat,
          inputProps: props.inputProps,
        }}
        InputLabelProps={{ shrink: true }}
        fullWidth
        label={props.label}
        margin={props.margin ? props.margin : "dense"}
        variant={props.variant ? props.variant : "outlined"}
        required={props.required}
        error={props.errors ? true : false}
        helperText={props.errors ? props.errors.message : ""}
        disabled={props.disabled ? props.disabled : false}
        autoComplete={props.autoComplete ? props.autoComplete : "off"}
      />
    );
  }

  if (type === "mask" && maskPattern) {
    return (
      <TextField
        {...inputProps}
        InputProps={{
          inputComponent: MaskFormat,
          inputProps: {
            ...props.inputProps,
            maskPattern,
          },
        }}
        InputLabelProps={{ shrink: true }}
        fullWidth
        label={props.label}
        margin={props.margin ? props.margin : "dense"}
        variant={props.variant ? props.variant : "outlined"}
        required={props.required}
        error={props.errors ? true : false}
        helperText={props.errors ? props.errors.message : ""}
        disabled={props.disabled ? props.disabled : false}
        autoComplete={props.autoComplete ? props.autoComplete : "off"}
      />
    );
  }

  return (
    <TextField
      {...inputProps}
      inputRef={ref}
      InputLabelProps={{ shrink: true }}
      InputProps={InputProps || props.inputProps}
      fullWidth
      label={props.label}
      type={props.type ? props.type : "text"}
      margin={props.margin ? props.margin : "dense"}
      variant={props.variant ? props.variant : "outlined"}
      multiline={props.multiline}
      rows={props.rows}
      required={props.required}
      error={props.errors ? true : false}
      helperText={props.errors ? props.errors.message : ""}
      disabled={props.disabled ? props.disabled : false}
      autoComplete={props.autoComplete ? props.autoComplete : "off"}
    />
  );
};

export default MyInput;